<template>
  <div class="text-center">
    <v-dialog persistent v-model="dialog" max-width="1000">
      <template v-slot:activator="{ on, attrs }">
        <p id="addItemUsage" v-bind="attrs" v-on="on" @click="addItemUsage"></p>
      </template>
      <v-card style="position: relative">
        <v-form
          ref="entryForm"
          @submit.prevent="submit"
          style="position: relative"
        >
          <v-card
            flat
            style="
              z-index: 2;
              position: sticky;
              top: 0;
              background: white;
              border-bottom: 1px solid black;
              margin-bottom: 10px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 10px;
              "
            >
              <v-toolbar-title class="overline"
                ><p style="font-size: 20px; margin: 0; font-weight: bold">
                  Add Item
                </p>
              </v-toolbar-title>
            </div>
            <v-btn x-small icon class="ma-2" @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card>

          <v-row no-gutters style="padding: 15px">
            <!-- <v-row
              no-gutters
              v-if="
                getUserProfile.employee.company.plant_id == '6' &&
                  (getUserProfile.employee.department_id == 1 ||
                    getUserProfile.employee.department_id == 3)
              "
            > -->
            <v-row no-gutters>
              <v-col md="12" style="padding: 0">
                <!-- <v-col md="12" style="padding: 0"> -->
                <div style="padding: 0 10px">
                  <v-col cols="4" style="padding: 0; margin-bottom: 10px">
                    <p
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Company Asset
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-select
                      dense
                      v-model="company_id"
                      :items="dropdownCompany"
                      outlined
                      item-text="name"
                      item-value="id"
                      return-id
                    ></v-select>
                  </v-col>
                </div>
              </v-col>
            </v-row>
            <v-col md="12" style="padding: 0; margin-bottom: 20px">
              <div style="padding: 0 10px">
                <v-col cols="4" style="padding: 0; margin-bottom: 10px">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Nama Aset
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0"
                  ><v-autocomplete
                    dense
                    v-model="selectedAsset"
                    outlined
                    item-text="name"
                    item-id="id"
                    hide-details
                    hide-no-data
                    return-object
                    label="- ketik disini -"
                    :loading="loading"
                    :items="result"
                    :search-input.sync="search"
                    @keydown.enter.prevent
                    clearable
                    @change="selectedAssetWatcher"
                    :filter="customFilter"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title class="d-flex">
                            <span style="font-size: 12px; margin-right: 5px">
                              <!-- ({{ data.item.code }}) -->
                            </span>
                            {{ data.item.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                  <!-- @keydown.enter.prevent="enterSearch(search)" -->
                </v-col>
              </div>
            </v-col>
            <v-col md="12" style="padding: 0; margin-bottom: 20px">
              <div style="padding: 0 10px">
                <v-col cols="4" style="padding: 0; margin-bottom: 10px">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Pilih Lot
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-autocomplete
                    v-model="selectedlot"
                    chips
                    deletable-chips
                    multiple
                    small-chips
                    outlined
                    item-text="name"
                    item-id="id"
                    hide-details
                    hide-no-data
                    return-object
                    :items="lotDetail != null ? lotDetail : []"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title class="d-flex">
                            {{ data.item.name }}

                            <span style="font-size: 12px; margin-left: 5px">
                              ({{ data.item.qty }})
                            </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template></v-autocomplete
                  >
                </v-col>
              </div>
            </v-col>
            <!-- <v-col md="12" style="padding: 0; margin-bottom: 20px">
              <div style="padding: 0 10px">
                <v-col cols="4" style="padding: 0; margin-bottom: 10px">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Stock terkini
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    dense
                    :value="selectedlot"
                    outlined
                    min="0"
                    type="number"
                  />
                </v-col>
              </div>
            </v-col> -->

            <v-col md="12" style="padding: 0; margin-bottom: 20px">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <v-data-table
                    mobile-breakpoint="0"
                    :headers="lotHeaders"
                    :items="selectedlot"
                    class="elevation-1 mx-auto"
                    style="
                      width: 100%;
                      margin-bottom: 10px;
                      border: 1px solid #e0e0e0;
                    "
                    :items-per-page="10"
                    hide-default-footer
                    ><template v-slot:[`header.action`]>
                      <span
                        >Aksi
                        <v-tooltip bottom>
                          <template v-slot:activator="{ attrs, on }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="red lighten-2"
                              style="margin: 0"
                              x-small
                              @click="selectedlot = []"
                              :disabled="selectedlot.length == 0"
                            >
                              mdi-delete-circle
                            </v-icon>
                          </template>
                          <span>Delete All</span>
                        </v-tooltip>
                      </span> </template
                    ><template v-slot:[`item.action`]="{ index }">
                      <div style="font-size: 11px; width: 40px; padding: 0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ attrs, on }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              text
                              icon
                              x-small
                              color="red lighten-2"
                              @click="selectedlot.splice(index, 1)"
                            >
                              <v-icon x-small>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:[`item.name`]="{ item }">
                      <div style="font-size: 10px; width: 160px; padding: 0">
                        {{ item.asset_name }}
                      </div>
                    </template>
                    <template v-slot:[`item.lot_no`]="{ item }">
                      <div style="font-size: 10px; width: 60px; padding: 0">
                        {{ item.name }}
                      </div>
                    </template>
                    <template v-slot:[`item.company_name`]="{ item }">
                      <div style="font-size: 10px; width: 180px; padding: 0">
                        {{ item.company_name }}
                      </div>
                    </template>
                    <template v-slot:[`item.current_location_name`]="{ item }">
                      <div style="font-size: 10px; width: 180px; padding: 0">
                        {{
                          item.current_company_name +
                          ' - ' +
                          item.current_location_name
                        }}
                      </div>
                    </template>
                    <template v-slot:[`item.qty_available`]="{ item }">
                      <div style="font-size: 10px; width: 60px; padding: 0">
                        {{ item.qty }}
                      </div>
                    </template>
                    <template v-slot:[`item.qty_used`]="{ item }">
                      <div style="padding: 0">
                        <div style="height: 40px; width: 90px">
                          <v-text-field
                            v-model="item.qty_used"
                            dense
                            outlined
                            type="number"
                            min="0"
                            max="9999"
                            :rules="[
                              (v) => v >= 0 || 'Min 0',
                              (v) => v <= 9999 || 'Max 9999'
                            ]"
                          />
                        </div>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </div>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-btn
              type="submit"
              color="primary"
              style="
                color: white;
                margin: auto;
                width: 95%;
                margin-bottom: 20px;
              "
            >
              simpan
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import buildType from '../../../../services/buildType'
import { mapGetters } from 'vuex'
export default {
  name: 'UsageFormAddItem',
  components: {},
  props: ['lotHeaders', 'dropdownCompany', 'formData'],
  data() {
    return {
      asset2: buildType.apiURL('asset2'),
      asset: buildType.apiURL('asset'),
      dialog: false,
      search: null,
      loading: false,
      selectedAsset: [],
      result: [],

      selectedlot: [],
      lotDetail: null,
      company_id: null
    }
  },
  watch: {
    search(val) {
      // console.log('val')
      if (this.search == null || this.search == '') {
        return (this.result = [])
      }
      return val && val != this.select && this.querySelections(val)
    },
    company_id(val) {
      this.result = []
    }
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  methods: {
    customFilter(item, queryText, itemText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
        -1
        //   ||
        // item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
        //   -1
      )
    },
    selectedAssetWatcher(val) {
      console.log('selectedAssetWatcher', this.selectedAsset)
      if (this.selectedAsset == null) {
        return (this.selectedAsset = [])
      }
      return this.initLot()
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    // enterSearch(val) {
    //   val && val !== this.select && this.querySelections(val)
    // },
    querySelections(v) {
      this.loading = true
      axios
        .get(
          `${this.asset}asset/dropdown?keyword=${v}&company_id=${
            this.company_id == 0 ? '' : this.company_id
          }`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            this.result = res.data.data
          }
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
        })
    },

    initLot() {
      // console.log(this.getUserProfile.employee.company.plant_id)
      let url = `${this.asset}asset/lot/dropdown?asset=${this.selectedAsset.id}`
      if (this.company_id) {
        url = url + `&company_id=${Number(this.company_id)}`
        // `&company_id=${Number(this.getUserProfile.employee.company.plant_id)}`
      } else {
        url = url + '&company_id='
      }
      axios
        .get(url)
        .then((res) => {
          console.log('lot/dropdown', res)
          if (res.data.status_code == '00') {
            this.lotDetail = res.data.data
          } else {
            this.lotDetail = []
          }
        })
        .catch((err) => {
          console.log(err)
          this.lotDetail = []
        })
    },
    clear() {
      this.$emit('loadPage')

      this.result = []
      this.selectedAsset = []
      this.search = null
      this.selectedlot = []
      this.lotDetail = null
      this.company_id = 0
    },
    close() {
      this.clear()
      this.dialog = false
    },
    addItemUsage() {
      if (this.formData && this.formData.company) {
        this.company_id = Number(this.formData.company.id)
      }
    },
    submit() {
      if (this.selectedlot.length > 0) {
        this.$emit('getLot', this.selectedlot)
      }
      this.close()
    }
  }
}
</script>
<style lang="scss" scoped></style>
